import React from 'react';
import {
  Badge,
  Button,
  Card,
  CardSection,
  CardFooter,
  EmptyLayout,
  Gutter,
  SmallHeader,
  Paragraph,
  Visible,
} from '@axiom/ui';

import ErrorGraphic from '../../public/svg/error.svg';

export const WorkFeedActionNeeded = () => {
  return (
    <Card name="WORK_FEED_ACTION_NEEDED">
      <CardSection divider>
        <EmptyLayout
          graphic={
            <Visible name="ERROR_GRAPHIC_VISIBLE" only="largeScreen">
              <ErrorGraphic width="94px" height="100px" />
            </Visible>
          }
          graphicPosition="left"
        >
          <Badge name="ACTION_NEEDED_BADGE" background="red">
            Action Needed
          </Badge>
          <Gutter bottom="16px" />
          <SmallHeader name="HEADER_TEXT">
            Update your profile and availability to see opportunities
          </SmallHeader>
          <Gutter bottom="16px" />
          <Paragraph name="DESCRIPTION_TEXT">
            Axiom needs you to resolve all of your action needed items and/or
            update your availability before you're granted access to Opportunity
            Feed. This ensures you're always ready to be recommended to clients.
          </Paragraph>
        </EmptyLayout>
      </CardSection>
      <CardFooter>
        <Button name="UPDATE_PROFILE" to="../../../profile">
          Update Profile
        </Button>
      </CardFooter>
    </Card>
  );
};
